import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { CommonService } from '@app/service/common.service';
import { UtilService } from '@app/service/util.service';
import { RecruitService } from '@home/service/recruit.service';

import { Globals } from '@app/service/globals.service';
import { ToastrService } from 'ngx-toastr';
import { CustomValidator } from '@app/service/custom.validators';

@Component({
  selector: 'app-recruit-add1',
  templateUrl: './recruit-add1.component.html',
  styleUrls: ['./recruit-add1.component.scss']
})
export class RecruitAdd1Component implements OnInit {

  /*******************************************************************************
    설명 : 전역 변수 선언부
  *******************************************************************************/
  public form: FormGroup;
  public formErrors = {};

  params: any = {
    tab: '',      // 구인, 구직 : offer, search
    type: '',     // 리스트, 내용보기, 쓰기, 수정 : list, view, write, modify
    boardSeq: 0,  // 게시판 순번
    no: 1,        // 현재 페이지
    row: 10,      // 페이지당 보여줄 갯수
  };

  board: any = [];

  memNo: any = '';
  salary: any = [];
  recuritmentPart: any = [];
  academicAbility: any = [];
  career: any = [];

  daumAddressOptions =  {
    class: ['btn', 'zip-btn']
  };

  constructor(
    private router: Router,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,

    private formBuilder: FormBuilder,
    private utilService: UtilService,
    private recruitService: RecruitService,
    private toastrService: ToastrService,
    private globals: Globals,
  ) {
    this.buildForm();
  }

  /*******************************************************************************
    설  명 : 폼생성
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  buildForm(): void {
    this.form = this.formBuilder.group({
      board_seq: ['', ''],
      subject: ['', [Validators.required] ],
      contents: ['', [Validators.required] ],
      mem_no: [this.memNo, [] ],
      company_name: ['', [Validators.required] ],
      board_id: ['', [] ],
      sdate1: ['', [Validators.maxLength(4), CustomValidator.numeric]],
      sdate2: ['', [Validators.maxLength(2), CustomValidator.numeric]],
      sdate3: ['', [Validators.maxLength(2), CustomValidator.numeric]],
      edate1: ['', [Validators.maxLength(4), CustomValidator.numeric]],
      edate2: ['', [Validators.maxLength(2), CustomValidator.numeric]],
      edate3: ['', [Validators.maxLength(2), CustomValidator.numeric]],
      recruitment_period_sdate: ['', [] ],
      recruitment_period_edate: ['', [] ],
      is_rolling_recruitment:  ['', [Validators.required] ],
      recruitment_number: ['', [Validators.required] ],
      salary_seq: ['', [Validators.required] ],
      charge: ['', [] ],
      recuritment_part_seq: ['', [Validators.required] ],
      academic_ability_seq: ['', [Validators.required] ],
      career_seq: ['', [Validators.required] ],
      tel1: ['', [Validators.maxLength(4), CustomValidator.numeric] ],
      tel2: ['', [Validators.maxLength(4), CustomValidator.numeric] ],
      tel3: ['', [Validators.maxLength(4), CustomValidator.numeric] ],
      fax1: ['', [Validators.maxLength(4), CustomValidator.numeric] ],
      fax2: ['', [Validators.maxLength(4), CustomValidator.numeric] ],
      fax3: ['', [Validators.maxLength(4), CustomValidator.numeric] ],
      tel: ['', [] ],
      fax: ['', [] ],
      contact_email: ['', [] ],
      website: ['', [] ],
      zipcode: ['', [] ],
      address: ['', [] ],
      address_detail: ['', [] ],
    });

    this.form.valueChanges.subscribe(data => {
      this.utilService.updateFormErrors( this.form, this.formErrors );
    });
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.params.tab = ( typeof params.tab === 'undefined' || params.tab == '' ) ? 'offer' : params.tab;
      this.params.type = ( typeof params.type === 'undefined' || params.type == '' ) ? 'list' : params.type;
      this.params.no = ( typeof params.no === 'undefined' || params.no == '' ) ? '1' : params.no;
      this.params.boardSeq = ( typeof params.boardSeq === 'undefined' || params.boardSeq == '' ) ? '0' : params.boardSeq;

      // indicator 표시 숨김
      setTimeout (() => {
        this.globals.indicator.next(true);

        this.getCommonListCode('rs');
        this.getCommonListCode('rp');
        this.getCommonListCode('ra');
        this.getCommonListCode('rc');

        if (this.params.type === 'modify') {
          this.getBoardJobOfferDetail();
        } else {
          const today = new Date();
          this.board.sdate1 = today.getFullYear().toString();
          this.board.sdate2 = (today.getMonth() + 1).toString().padStart(2, '0');
          this.board.sdate3 = today.getDate().toString().padStart(2, '0');

          const nextMonthday = new Date();
          nextMonthday.setMonth(nextMonthday.getMonth() + 2);
          this.board.edate1 = nextMonthday.getFullYear().toString();
          this.board.edate2 = nextMonthday.getMonth().toString().padStart(2, '0');
          this.board.edate3 = nextMonthday.getDate().toString().padStart(2, '0');

          this.board.is_rolling_recruitment = 0;
          this.globals.indicator.next(false);
        }
      });
    });
  }

  /*******************************************************************************
    설  명 : 공통코드 - 급여, 모집분야, 학력, 경력구분
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  async getCommonListCode(code) {
    await this.commonService.getCommonListCode(code).then(response => {
      if ( response.ResultCode ) {
        switch (code) {
          case 'rs':
            this.salary = response.data;
            this.board.salary_seq = response.data[0].seq;
            break;
          case 'rp':
            this.recuritmentPart = response.data;
            this.board.recuritment_part_seq = response.data[0].seq;
            break;
          case 'ra':
            this.academicAbility = response.data;
            this.board.academic_ability_seq = response.data[0].seq;
            break;
          case 'rc':
            this.career = response.data;
            this.board.career_seq = response.data[0].seq;
            break;
        }
      }
    }, error => {
      this.globals.indicator.next(false);
      this.toastrService.error('구인 정보를 가져오는데 실패하였습니다.', '구인 정보');
    });
  }

  /*******************************************************************************
    설  명 : 날짜, 전화번호, 팩스번호 조합
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  makeData() {
    this.form.value.board_seq = this.params.boardSeq;
    this.form.value.mem_no = this.memNo;
    this.form.value.recruitment_period_sdate =
      [this.form.value.sdate1, this.form.value.sdate2.padStart(2, '0'), this.form.value.sdate3.padStart(2, '0')].join('-');
    this.form.value.recruitment_period_edate =
      [this.form.value.edate1, this.form.value.edate2.padStart(2, '0'), this.form.value.edate3.padStart(2, '0')].join('-');
    this.form.value.tel = [this.form.value.tel1, this.form.value.tel2, this.form.value.tel3].join('-');
    this.form.value.fax = [this.form.value.fax1, this.form.value.fax2, this.form.value.fax3].join('-');
  }

  /*******************************************************************************
    설  명 : 날짜, 전화번호, 팩스번호 분리
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  splitData(sdate, edate, tel, fax) {
    if (sdate != null) {
      sdate = sdate.split( '-' );
      this.board.sdate1 = sdate[0];
      this.board.sdate2 = sdate[1];
      this.board.sdate3 = sdate[2];
    }

    if (edate != null) {
      edate = edate.split( '-' );
      this.board.edate1 = edate[0];
      this.board.edate2 = edate[1];
      this.board.edate3 = edate[2];
    }

    if (tel != null) {
      tel = tel.split( '-' );
      this.board.tel1 = tel[0];
      this.board.tel2 = tel[1];
      this.board.tel3 = tel[2];
    }

    if (fax != null) {
      fax = fax.split( '-' );
      this.board.fax1 = fax[0];
      this.board.fax2 = fax[1];
      this.board.fax3 = fax[2];
    }
  }

  /*******************************************************************************
    설  명 : 구인 게시판 게시글 등록
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  setBoardJobOfferWrite() {
    if ( this.form.valid ) {
      this.recruitService.setBoardJobOfferWrite( this.form ).then( response => {
        if ( response.ResultCode ) {
          this.toastrService.success( response.ResultMessage, '구인정보 정보 저장');

          this.list();
        } else {
          this.toastrService.error( response.ResultMessage, '구인정보 정보 저장');
        }
      });
    } else {
      this.toastrService.error('필수 입력항목을 확인하시기 바랍니다.', '구인정보 정보 저장');
    }
  }

  /*******************************************************************************
    설  명 : 구인 게시판 게시글 수정
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  setBoardJobOfferModify() {
    if ( this.form.valid ) {
      this.recruitService.setBoardJobOfferModify( this.form ).then( response => {
        if ( response.ResultCode ) {
          this.toastrService.success( response.ResultMessage, '구인정보 정보 수정');

          this.list();
        } else {
          this.toastrService.error( response.ResultMessage, '구인정보 정보 수정');
        }
      });
    } else {
      this.toastrService.error('필수 입력항목을 확인하시기 바랍니다.', '구인정보 정보 수정');
    }
  }

  /*******************************************************************************
    설  명 : 구인 게시판 상세정보 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  getBoardJobOfferDetail() {
    this.recruitService.getBoardJobOfferDetail(this.params).then(response => {
      if ( response.ResultCode ) {
        this.board = response.data;
        this.splitData(response.data.recruitment_period_sdate, response.data.recruitment_period_edate
          , response.data.tel, response.data.fax);

        this.board.is_rolling_recruitment = parseInt(this.board.is_rolling_recruitment, 10);
      }
      this.globals.indicator.next(false);
    }, error => {
      this.globals.indicator.next(false);

      this.toastrService.error('구인 정보를 가져오는데 실패하였습니다.', '구인 정보');
    });
  }

  /*******************************************************************************
    설  명 : 구인구직 등록 / 수정
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  write() {
    this.makeData();
    this.utilService.makeFormDirtyAndUpdateErrors(this.form, this.formErrors);

    if ( this.params.type === 'write') {
      this.setBoardJobOfferWrite();
    } else if ( this.params.type === 'modify' ) {
      this.setBoardJobOfferModify();
    }
  }

  /*******************************************************************************
    설  명 : 목록으로
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  list() {
    this.params.type = 'list';

    this.router.navigate(
      [location.pathname],
      {
        relativeTo: this.activatedRoute,
        queryParams: this.params,
        queryParamsHandling: '', // remove to replace all query params by provided
    });
  }

  /*******************************************************************************
    설  명 : 다음주소창에서 클릭시 처리
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  setDaumAddressApi(data) {
    // 여기로 주소값이 반환
    this.form.patchValue({
      zipcode: data.zip,
      address: data.addr,
    });

    $('#address_detail').focus();
  }
}
